import { useState } from 'react';
import { getValuableVariables } from '@anytag/shared-utils';
import { ParamsSearchReturnType } from '@anytag/shared-hooks';
import { Maybe, useAllXHSInfluencersQuery, XhsInfluencer } from '@anytag/graphql';
import { formatInfluencerProfile } from '../utils';
import { XhsInfluencersSearchSchemaType, XhsInfluencersProps } from '../schemaTypes';
import { useGetInfluencersQueryVariables } from '../../hooks';

type Props = Pick<ParamsSearchReturnType<XhsInfluencersSearchSchemaType>, 'page' | 'limit' | 'filter' | 'sort'> &
  Pick<XhsInfluencersProps, 'getCurrentProfiles'>;

export const useXhsInfluencersList = ({ page, sort, limit, filter, getCurrentProfiles }: Props) => {
  // Using data directly from query can be empty if skipSearch is true
  // But we still want to keep old data in that case, so we store it in state
  const [data, setData] = useState<{
    totalNumber?: number;
    xhsAccounts?: Maybe<readonly XhsInfluencer[]>;
  }>();
  const { skipSearch, variables } = useGetInfluencersQueryVariables({ page, limit, filter });
  const { loading } = useAllXHSInfluencersQuery({
    skip: skipSearch || !filter,
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
    variables: getValuableVariables({ ...variables, orderBy: sort }),
    onCompleted: ({ allXHSInfluencers }) => {
      setData({
        xhsAccounts: allXHSInfluencers.xhsAccounts,
        totalNumber: allXHSInfluencers.totalNumber
      });
      getCurrentProfiles?.(allXHSInfluencers.xhsAccounts?.map(formatInfluencerProfile) || []);
    }
  });

  return {
    loading,
    totalRecords: data?.totalNumber || 0,
    listRecords: data?.xhsAccounts?.map(formatInfluencerProfile) || []
  };
};
